/* eslint-disable react/no-multi-comp */
import React, {useContext, useEffect, useState} from 'react';
import styled from 'styled-components';
import {Redirect} from 'react-router-dom';
import {withRouter} from 'react-router-dom';

import * as RouteNames from '../../common/routeNames';
import { setUserInfo } from '../../common/apiSetUtilities';
import { showAlert, showPrompt } from '../../common/utilities';
import { Capacitor } from '@capacitor/core';
// import { NavLink as RouterNavLink } from 'react-router-dom';
import { checkForStudyId } from '../../common/apiGetUtilities';
import { useStudy } from '../../context/StudyContext';
import StudyClaimDialog from '../../dialogs/StudyClaimDialog';
import { getEnrollmentHint } from '../../common/apiStudyUtilities';
import { debugLog } from '../../common/debugUtilities';
import {
  Avatar,
  Button,
  IconButton,
  Card as MuiCard,
  CardContent,
  Checkbox,
  Divider as MuiDivider,
  FormControlLabel,
  Grid,
  Snackbar,
  TextField,
  Typography
} from '@material-ui/core';
import { spacing } from '@material-ui/system';
import validator from 'validator';
import {isMobile, isBrowser, isIOS, isAndroid} from 'react-device-detect';
import { useUserState, useUserDispatch, UserActionTypes} from '../../context/UserContext';
import { SharedSnackbarConsumer } from '../../context/SnackbarContext';
import useStyles from './styles';
import { convertUserDataToUserPropType } from '../../common/entityUtilities';
import { checkIfEmailIsTaken } from '../../common/apiGetUtilities';
import TOS from '../documents/TOS';
import { sleep } from '../../common/utilities';
import { useTranslation} from 'react-i18next';
const Card = styled(MuiCard)(spacing);
const Divider = styled(MuiDivider)(spacing);

const CenteredContent = styled.div`
  text-align: center;
`;


function UserSettings(props){
  const classes = useStyles();
  // Global
  const userState = useUserState();
  const userDispatch = useUserDispatch();

  const {t, i18n} = useTranslation(); 
 
  // local
  const [tosChecked, setTosChecked] = useState(false);
  const [displayName, setDisplayName] = useState('');
  const [photoURL, setPhotoURL] = useState('');
  const [registeredDate, setRegisteredDate] = useState(userState.createdAt);
  const [email, setEmail] = useState(userState.email);
  const [uiemail, setUiEmail] = useState(userState.email);
  const [userEmail, setUserEmail] = useState(userState.email);
  const [studyIdAlertShown, setStudyIdAlertShown] = useState(false);
  const [studyid, setStudyid] = useState(t('notenrolled',{ns:'usersettings'}));
  const [isStudyIdValid, setStudyIdValid] = useState(false);
  const [studyidValidationMessage, setStudyidValidationMessage] = useState('Enter a valid study ID.');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [toDashboard, setToDashboard] = useState(false);
  // study linkage (cribsy-api docs/ENROLLMENT.md; decisions D18-D20)
  const study = useStudy();
  const [claimOpen, setClaimOpen] = useState(false);
  const [claimReason, setClaimReason] = useState('settings');
  const [navigateAfterClaim, setNavigateAfterClaim] = useState(false);

  const [firstName, setFirstName] = useState(userState.firstname);
  const [lastName, setLastName] = useState(userState.lastname);
  const [signature, setSignature] = useState(userState.signature);
  const [authProvider, setAuthProvider] = useState('');
  const [isEmailValid, setIsEmailValid] = useState(true);
  const [emailValidationMessage, setEmailValidationMessage] = useState('');

  const [tosOpen, setTOSOpen] = useState(false);
  const handleClose = ()=>{
    setTOSOpen(false);
  }

  useEffect(() => {

    const setFunction = () => {

        // is it better to load data here then cache it for future usage?
        // instead of having all the info a larger entitiy.
        let localEmailCopy = userState.localEmail;

        //debugLog('[UserSettings] The user state', JSON.stringify(userState));
        debugLog('[UserSettings] userState email:', userState.email);
        const providerData = userState.firebaseUser.firebaseUserObject?.providerData[0];
        debugLog('[UserSettings] Auth Provider ID:', providerData?.providerId);
        // can be 'password'
        // 'google.com'
        // or 'phone' 
        //
        setAuthProvider(providerData?.providerId);

        if (providerData?.providerId == 'phone'){
          setPhoneNumber(providerData?.phoneNumber); // this should be saved in the emmauser db object
          debugLog('Provider says phone number is:', providerData?.phoneNumber);
        
        }

        setDisplayName(userState.localDisplayName);
        if (userState.firebaseUser.email !== null){
          debugLog('Setting userEmail from firebaseUser email:', userState.firebaseUser.email);
          setEmail(userState.firebaseUser.email);
          setUserEmail(userState.firebaseUser.email);
          setUiEmail(userState.firebaseUser.email);
          localEmailCopy = userState.firebaseUser.email;
          setStudyIdValid(false);
        }
        else{
        debugLog('Firebase user did not have email');
        debugLog('user email:', userEmail);
        debugLog('userState email:', userState.email);
        if (userEmail != null && userEmail != undefined && userEmail != '') {
            debugLog('Setting userEmail to:',userEmail);
            setEmail(userEmail);
            //the state variable email is never used anywhere!
            
            setUserEmail(userEmail);
            setUiEmail(userEmail);
            localEmailCopy = userEmail;
            setIsEmailValid(true);
            setEmailValidationMessage('');
            setStudyIdValid(false);
          
        }
        else if (userState.localEmail != null && userState.localEmail != undefined && userState.localEmail != ''){
            debugLog('Setting userEmail from userState localEmail:', userState.localEmail);
            setEmail(userState.localEmail);
            setUserEmail(userState.localEmail);
            setUiEmail(userState.localEmail);
            localEmailCopy = userState.localEmail;
            setIsEmailValid(true);
            setStudyIdValid(false);
            setEmailValidationMessage('');
        }
        }

        if (userState.tos){
          setTosChecked(true);
        }

        debugLog('[UserSettings] userEmail:', userEmail);
        debugLog('[UserSettings] localEmailCopy:', localEmailCopy);
        debugLog('userState:', userState);
        if(userState.createdAt){
        // can you convert userState.created to a date string of format 'YYYY-MM-DD'?
          var date = new Date(userState.createdAt) ;
          // convert to a string of format 'YYYY-MM-DD' without the time
          const dateString = date.toLocaleDateString('en-EN', { year: 'numeric', month: '2-digit', day: '2-digit' });
          const spanishDateString = date.toLocaleDateString('es-ES', { year: 'numeric', month: '2-digit', day: '2-digit' });
          
          if (i18n.language == 'es' || i18n.language == 'es-ES'){
            debugLog('Spanish date:', spanishDateString);
            setRegisteredDate(spanishDateString);
          } else if (i18n.language == 'en' || i18n.language == 'en-EN' || i18n.language == 'en-US'){
            debugLog('English date:', dateString);
            setRegisteredDate(dateString);
          }
          
        }
        setPhotoURL(userState.firebaseUser.photoURL);

        if (isIOS || isAndroid) {

          // authProvider can be 'password'
          // 'google.com'
          // or 'phone' 
          // for 'google.com' and 'password', you already have a userEmail set
          // 'phone' pathway you need user to enter email
          debugLog('showPrompt?', userEmail);
          debugLog('authProvider:', providerData?.providerId);
          debugLog('localEmailCopy:', localEmailCopy);
          if (providerData?.providerId == 'phone' && 
            (localEmailCopy == '' || localEmailCopy == undefined || localEmailCopy == null) 
            // && !Capacitor.isNativePlatform()
            // use Capacitor.isNativePlatform() to check if the platform is native/mobile
            ){
            showPrompt();
          }
        }
    };

    if (userState.firebaseUser) {
        setFunction();
    }
   
    


  }, []);



  // Phase 1 families: show the study ID on file in study-participants when no enrollment is linked (display only).
  // The old "Need Study ID" alert is gone: the app never blocks or nags a family that has no pending claim (D19).
  useEffect ( ()=>{
    if (!userEmail || !userState?.firebaseUser) return;
    checkForStudyId(userState.firebaseUser, userEmail)
      .then(value => { if (value) { setStudyid(value); setStudyIdValid(true); } })
      .catch(()=>{});
  }, [userEmail]);

  const showPrompt = async() => {
    debugLog('Showing email dialog');

    // can be 'password'
    // 'google.com'
    // or 'phone' 
    // for 'google.com' and 'password', you already have a userEmail set
    // 'phone' pathway you need user to enter email
    debugLog('AUTHPROVIDER:', authProvider);
    debugLog('isIOS', isIOS);
    debugLog('studyidValid? ', isStudyIdValid);
    debugLog('userEmail:', userEmail);

    const value = await showAlert(t('needinfotitle',{ns:'usersettings'}) ,
      t('needinfomsg',{ns:'usersettings'}), t('needinfook',{ns:'usersettings'}));

  };

  const goToDashboard = () => {
    debugLog('redirect to dashboard');
    setToDashboard(true);
    props.history.push('/');
    sleep(1000);
  };

  const claimDialogClosed = () => {
    setClaimOpen(false);
    if (navigateAfterClaim) {
      setNavigateAfterClaim(false);
      goToDashboard();
    }
  };

  const modifyUserSettings = () => {
    //Firebase user should always exist since that is our main log in.
    const firebaseUser = userState.firebaseUser;

    // Also note that an empty use is created if no matching user was found
    // in the mongodb. It is of type UserProps and is used by the user context

    // the call to register the user needs to be put elsewhere
    // but for now this will do since no other function calls the setuser
    const addingNewUserToDb = (userState.authLevel < 0); // -1 for unregisterd
    // Check to see if it is an unregistered user
    // then register or update accordingly.
    const mongoUserValuesToUpdate= {};//:Partial<EmmaUserSchemaProps> 
    if(addingNewUserToDb){
      mongoUserValuesToUpdate.authLevel = 0;
      mongoUserValuesToUpdate.created = new Date();//new Date().toISOString();
      mongoUserValuesToUpdate.uid = firebaseUser.uid;
      mongoUserValuesToUpdate.email = firebaseUser.email;
      mongoUserValuesToUpdate.phoneNumber = phoneNumber;
      debugLog('firebaseuser email:', firebaseUser.email);
    }
    mongoUserValuesToUpdate.firstname = firstName;
    mongoUserValuesToUpdate.lastname = lastName;

    if (firebaseUser.email === null){
      let lowercaseEmail = String(userEmail).toLowerCase();
      mongoUserValuesToUpdate.email = lowercaseEmail;
      debugLog('useremail to update with:', lowercaseEmail);
    }
    mongoUserValuesToUpdate.tos = true; // has accepted TOS

    debugLog('uservalues to update for new user:', mongoUserValuesToUpdate);
    setUserInfo(firebaseUser, userState._id, mongoUserValuesToUpdate)
      .then(async updatedUser=>{
        // The updated user will have the emmauserid/mongoid
        debugLog('The updated cribsyuser:', updatedUser);
        if (updatedUser?.tos) {
          debugLog('settoschecked to true');
          setTosChecked(true);
        }
        const fixedUser = convertUserDataToUserPropType(updatedUser);
        debugLog('The user', fixedUser);
        const createdDateString = new Date(updatedUser.createdAt).toDateString();
        debugLog('Created at date string:', createdDateString);
        setRegisteredDate(createdDateString);
        userDispatch({ type: UserActionTypes.UPDATE, ...fixedUser });
        if (addingNewUserToDb) {
          // Registration moment (D18): offer the claim code when a letter is waiting for this family, or a link brought one.
          const claimWaiting = study.pendingCode ? true : await getEnrollmentHint(firebaseUser);
          if (claimWaiting) {
            setClaimReason('registration');
            setNavigateAfterClaim(true);
            setClaimOpen(true);
            return;
          }
        }
        goToDashboard();
      });
  };

  const buttonText = userState.authLevel < 0 ? t('registerbutton',{ns:'usersettings'}): t('updatebutton',{ns:'usersettings'});

  if (toDashboard) {
    debugLog('Rerouting to dashboard page');
    return (<Redirect to={RouteNames.DASHBOARD}/>);
  } else {
  return (
    <React.Fragment>
      <div>
        <Typography
          display="inline"
          gutterBottom
          variant="h3"
        >
          {t('pagetitle',{ns:'usersettings'})}
        </Typography>
        <Divider my={2}/>
        
        <Grid
          container
          spacing={2}
        >
          <Grid
            item
            xs={12}
          >
                
            <Card mb={6}>
            <CardContent>
                <Grid
                container
                spacing={3}
                xs={12}
                sm={12}
                md={12}
                >

                <Grid item md={8} xs={12} sm={12}>

                  <Typography
                  gutterBottom
                  variant="h4"
                  >
                  {userState.authLevel < 0 &&
                      <Grid item md={12} xs={12} sm={12}>

                      <Typography gutterBottom variant='h6' color='secondary'> 
                      {t('intromsg',{ns:'usersettings'})}
                      </Typography>

                      </Grid>
                  }
                  </Typography>
                </Grid>
                <Grid
                    item
                    md={8}
                    xs={8}
                    sm={8}
                >
                  
                    <TextField
                    id="useremail"
                    label={t('emaillabel',{ns:'usersettings'})}
                    fullWidth
                    disabled={authProvider !== 'phone'}
                    m={2}
                    
                    onChange={(e) => {
                      //debugLog('Value:', e.target.value);
                        if (validator.isEmail(e.target.value)){ //is the entered text in the right format for an email?

                        setEmailValidationMessage(t('emailok',{ns:'usersettings'}));
                        checkIfEmailIsTaken(userState?.firebaseUser, e.target.value).then(
                            //is there any other cribsy in the database with this email?
                            (status)=>{
                            debugLog('checkifemailistaken returned:', status);
                            if (!status){
                                setIsEmailValid(true);
                                setUserEmail(e.target.value);
                            }
                            else{
                                setEmailValidationMessage(t('emailtaken',{ns:'usersettings'}));
                                setIsEmailValid(false);
                            }
                            }
                        )
                        }
                        else {
                          setEmailValidationMessage(t('entervalidemail',{ns:'usersettings'}));
                          setIsEmailValid(false);
                        }
                    }}
                    value={uiemail}
                    variant="outlined"
                    />
                </Grid>

                <Grid
                    item
                    sm={4}
                    md={4}
                    xs={4}
                    >
                    <Typography variant='body2' color='primary'>
                        {emailValidationMessage}
                    </Typography>
                </Grid>
          

                <Grid
                    item
                    md={8}
                    xs={8}
                    sm={8}
                >
                    <TextField
                    id="firstname"
                    label={t('firstnamelabel',{ns:'usersettings'})} 
                    m={2}
                    onChange={(e)=>setFirstName(e.target.value)}
                    value={firstName}
                    variant="outlined"
                    />
                </Grid>
                <Grid
                    item
                    md={8}
                    xs={8}
                    sm={8}
                >
                    <TextField
                    id="lastname"
                    label={t('lastnamelabel',{ns:'usersettings'})}
                    m={2}
                    onChange={(e)=>{
                        debugLog('lastname:', e.target.value);
                        setLastName(e.target.value);}}
                    value={lastName}
                    variant="outlined"
                    />
                </Grid>
                <Grid
                    item
                    md={4}
                    xs={4} sm = {4}
                >
                    <CenteredContent>
                    {photoURL !== ''?
                        (
                        <Avatar
                            alt=""
                            src={photoURL}
                        />):
                        (
                        <Avatar
                            alt=""
                            src="/static/img/avatars/avatar-1.jpg"
                        />)}
                    </CenteredContent>
                </Grid>


                {userState.authLevel >=0 ?  (
                    <Grid
                    item
                    md={4}
                    xs={8}
                    sm={6}
                    >
                    <TextField
                        InputProps={{
                        readOnly: true
                        }}
                        id="registeredDate"
                        label={t('regdatelabel',{ns:'usersettings'})}
                        m={2}
                        value={registeredDate}
                        variant="outlined"
                    />
                    </Grid>): (<Grid item></Grid>)}
                </Grid>
                <Grid
                container
                spacing={2}
                xs={12}
                >


                {(userState.authLevel<0 ||  !userState?.tos) ?  
                  (<Grid container spacing={1}>
                     <Grid item md={12} xs={12} sm={12}>

                      <Typography gutterBottom variant='h6' color='secondary'> 
                      {t('toslabel',{ns:'usersettings'})}
                      </Typography>

                    </Grid>
                    <Grid item xs={8}>
                    <Button variant='outlined' color='primary' onClick={()=>{setTOSOpen(true)}}>{t('tosbutton',{ns:'usersettings'})}</Button>    
                  </Grid>
                  <Grid item xs={12}>
                    <FormControlLabel

                      label={t('toscheckbox',{ns:'usersettings'})}
                      control={
                        <Checkbox color='secondary' 
                        checked={tosChecked}
                        onChange={(event)=>{
                          setTosChecked(event?.target.checked);
                          debugLog('tos status:', event.target.checked);
                        }}
                      />
                      }
                    />
                  </Grid>
                  </Grid>): (<Grid item>
                    
                  </Grid>)
                }
                <Grid item xs={8} alignItems="center">

                    <SharedSnackbarConsumer>
                    {({openSnackbar}) => (
                        <Button
                        color="primary"
                        disabled={!isEmailValid || !tosChecked }
                        // allow user to register EVEN if no valid studyid
                        onClick= {()=> {
                            openSnackbar(t('savingmsg',{ns:'usersettings'}));
                            modifyUserSettings();}}
                        variant="contained"
                        >
                        {buttonText}
                        </Button>

                    )
                    }
                    </SharedSnackbarConsumer>


                </Grid>

                <Grid item xs={12}>
                  {/* Cribsy study card (D18): linked children, or the way to link one */}
                  <Typography variant='h6' gutterBottom>{t('settingstitle',{ns:'study'})}</Typography>
                  {study.enrollments.length > 0 ? (
                    study.enrollments.map(e => (
                      <Typography key={e.studyid} variant='body2'>
                        {t('settingslinked',{ns:'study', name: e.firstName || t('unnamedchild',{ns:'study'}), studyid: e.studyid})}
                      </Typography>
                    ))
                  ) : isStudyIdValid ? (
                    <Typography variant='body2'>{t('settingslegacy',{ns:'study', studyid})}</Typography>
                  ) : (
                    <Typography variant='body2' color='textSecondary'>
                      {study.pending ? t('bannertext',{ns:'study'}) : t('settingsnone',{ns:'study'})}
                    </Typography>
                  )}
                  {userState.authLevel >= 0 && (
                    <Button color='primary' variant='outlined' size='small' style={{marginTop: 8}}
                      onClick={()=>{ setClaimReason('settings'); setNavigateAfterClaim(false); setClaimOpen(true); }}>
                      {t('settingsbutton',{ns:'study'})}
                    </Button>
                  )}
                </Grid>


                </Grid>

            </CardContent>
            </Card>
                

          </Grid>
        </Grid>

        <StudyClaimDialog open={claimOpen} reason={claimReason} initialCode={study.pendingCode} onClose={claimDialogClosed} />
        <TOS
          isOpen = {tosOpen}
          handleClose={handleClose}
        />
      </div>
    </React.Fragment>
  );
  }
}



export default withRouter(UserSettings);

